import {
	AGENCY_PROJECT,
	GEOCMS_API,
	PROJECT_CAR,
	SUB_AGENCY_PROJECT,
	PROJECT_CCG,
	CHAR_SEPARATOR,
	CAR_TYPES,
	PROJECT_CRI,
	PROJECT_CGL,
	PROJECT_CVC,
	PROJECT_CCC,
	PROJECT_CGR,
	PROJECT_SOS,
	PROJECT_DOG,
	CURRENT_CRI_LIST,
	PROJECT_CSV,
	CSV_TYPES,
	FILIALI_PROJECT,
	DATA_SRC_TYPES,
	PROJECT_GRA,
	CURRENT_GRA_LIST,
	PROJECT_BSG,
	PROJECT_EUG,
	PROJECT_HGG,
	PROJECT_UGG,
	PROJECT_ASG,
	PROJECT_ING,
	PROJECT_NSG,
	PROJECT_STS
} from '../utils/Constants';
import { SHOW_ALL, TABS_TO_DISPLAY } from './portletConfiguration';

export function addProject(geoCMSMap, project) {
	const projectOptions = getProjectOptions(project);

	const projectObj = geoCMSMap.addProject(projectOptions);

	return projectObj;
}

export function getProjectOptions(project) {
	const projectOptions = {
		id: project,
		name: project,
		license: GEOCMS_API.license,
		styleProcess: null,
		infoWindowProcess: null,
		infoWindowOptions: null
	};

	if (project === PROJECT_CCG) {
		projectOptions.disableBalloonOnDemand = true;
	}

	return projectOptions;
}

export function isRankedAgency(result, ranking) {
	if (!ranking) ranking = 'QUOTATORE_AUTO';

	const tmp = result.getUserdataGroupValue(ranking, 'ranking', 0);
	if (tmp && tmp.trim() !== '') {
		return true;
	}

	return false;
}

export function getCarType(data) {
	const dataClassification = (data['Classificazione']??"").toLowerCase();

	if (dataClassification == 'carclinic') {
		return CAR_TYPES.CARCLINIC;
	} else if (dataClassification == 'metafora') {
		return CAR_TYPES.METAFORA;
	} else if (dataClassification == 'carsafe carrozzerie') {
		return CAR_TYPES.SOLUZIONE_CARROZZERIE;
	} else if (dataClassification == 'autosicura') {
		return CAR_TYPES.AUTOSICURA;
	} else if (dataClassification == 'riparte') {
		return CAR_TYPES.RIPARTE;
	} else {
		return CAR_TYPES.NETWORK_AXA;
	}
}

export function csvTypeConverter(originalType) {
	originalType = originalType.toUpperCase();

	if (
		originalType === 'CASA DI CURA' ||
		originalType === 'CASA DI CURA ACCREDITATA' ||
		originalType === 'CASA DI CURA PRIVATA' ||
		originalType === 'DAY HOSPITALDAY SURGERY'
	) {
		return CSV_TYPES.caseDiCura;
	} else if (
		originalType === 'CENTRO MEDICO(POLIAMBULATORIO)' ||
		originalType === 'CENTRO FISIOTERAPICO' ||
		originalType === 'OTTICO' ||
		originalType === 'CENTRO DIAGNOSTICO / POLISPECIALISTICO' ||
		originalType === 'CENTRO SPECIALISTICO'
	) {
		return CSV_TYPES.centriSpecialistici;
	} else if (originalType === 'CENTRO ODONTOIATRICO') {
		return CSV_TYPES.centriOdontoiatrici;
	} else if (
		originalType === 'OSPEDALE PUBBLICO' ||
		originalType === 'REPARTO SOLVENTI (INTRAMOENIA)'
	) {
		return CSV_TYPES.ospedali;
	}

	console.warn('CSV type Impossible to convert:', originalType);
	return CSV_TYPES.caseDiCura;
}

export function clearMap(geoCMSMap) {
	if (TABS_TO_DISPLAY.includes(AGENCY_PROJECT)) {
		geoCMSMap.getProject(AGENCY_PROJECT).clear();
		geoCMSMap.getProject(SUB_AGENCY_PROJECT).clear();
	}
	if (TABS_TO_DISPLAY.includes(PROJECT_CAR)) {
		geoCMSMap.getProject(PROJECT_CAR).clear();
	}
	if (TABS_TO_DISPLAY.includes(PROJECT_CRI)) {
		geoCMSMap.getProject(PROJECT_CCG).clear();
		geoCMSMap.getProject(PROJECT_CGL).clear();
		geoCMSMap.getProject(PROJECT_CVC).clear();
	}
	if (TABS_TO_DISPLAY.includes(PROJECT_GRA)) {
		geoCMSMap.getProject(PROJECT_CCC).clear();
		geoCMSMap.getProject(PROJECT_CGR).clear();
		geoCMSMap.getProject(PROJECT_DOG).clear();
		geoCMSMap.getProject(PROJECT_BSG).clear();
		geoCMSMap.getProject(PROJECT_EUG).clear();
		geoCMSMap.getProject(PROJECT_HGG).clear();
		geoCMSMap.getProject(PROJECT_UGG).clear();
		geoCMSMap.getProject(PROJECT_ASG).clear();
		geoCMSMap.getProject(PROJECT_ING).clear();
		geoCMSMap.getProject(PROJECT_NSG).clear(); // TODO: attivare
		geoCMSMap.getProject(PROJECT_STS).clear(); // TODO: attivare
	}
	if (TABS_TO_DISPLAY.includes(PROJECT_CSV)) {
		geoCMSMap.getProject(PROJECT_CSV).clear();
	}
}

export function getCompleteAddress(data, projectId) {
	let address = '';

	if (projectId === AGENCY_PROJECT || projectId === SUB_AGENCY_PROJECT) {
		address =
			capitalize(data['Indirizzo']) +
			', ' +
			capitalize(data['Nome comune']) +
			' (' +
			data['Provincia'] +
			')';
	} else if (projectId === PROJECT_CAR) {
		address =
			capitalize(data['Indirizzo']) +
			', ' +
			capitalize(data['Citta']) +
			' (' +
			data['Prov'] +
			')';
	} else if (CURRENT_CRI_LIST.includes(projectId)) {
		if (projectId === PROJECT_CCG) {
			address =
				data['street'] + ' ' + data['houseno'] + ', ' + data['city'];
		} else if (projectId === PROJECT_CGL) {
			address =
				data['Indirizzo'] +
				', ' +
				data['Città'] +
				', ' +
				data['CAP'] +
				' (' +
				data['Prov'] +
				')';
		} else if (projectId === PROJECT_CVC) {
			address =
				data['Indirizzo'] +
				', ' +
				data['Località'] +
				', ' +
				data['Codice Postale'] +
				' (' +
				data['Provincia'] +
				')';
		}
	} else if (CURRENT_GRA_LIST.includes(projectId)) {
		if (projectId === PROJECT_CCC) {
			address =
				data['INDIRIZZO'] +
				', ' +
				data['LOCALITA'] +
				', ' +
				data['CAP'] +
				' (' +
				data['PROV'] +
				')';
		} else if (projectId === PROJECT_CGR) {
			address =
				data['INDIRIZZO'] +
				', ' +
				data["LOCALITA'"] +
				' (' +
				data['PROV'] +
				')';
		} else if (projectId === PROJECT_SOS) {
			address =
				data['Indirizzo'] +
				', ' +
				data['CAP'] +
				' (' +
				data['Provincia'] +
				')';
		} else if (projectId === PROJECT_NSG) {
			address =
				data['Indirizzo'] +
				', ' +
				data['COMUNE'] +
				' (' +
				data['PROVINCIA'] +
				')';
		} else if (projectId === PROJECT_STS) {
			address =
				data['Indirizzo'] +
				', ' +
				data['COMUNE'] +
				' (' +
				data['PROVINCIA'] +
				')';
		} else {
			address = data['Indirizzo'];
		}
	} else if (projectId === PROJECT_CSV) {
		address =
			data['INDIRIZZO'] +
			', ' +
			data['COMUNE'] +
			' (' +
			data['PROVINCIA'] +
			')';
	}

	return address;
}

export function capitalize(phrase) {
	return phrase
		.toLowerCase()
		.split(' ')
		.map((word) => {
			if (
				word.length === 4 &&
				word.charAt(0) === '(' &&
				word.charAt(3) === ')'
			)
				return word.toUpperCase();
			return word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(' ');
}

export function setFilterResultsNumber(filter, number) {
	if (!filter) return;

	filter.resultsNumber = number;
}

export function getFilter(projectFilters, key) {
	if (!projectFilters || projectFilters.length === 0) return null;

	for (let i = 0; i < projectFilters.length; i++) {
		const filter = projectFilters[i];
		if (filter.key === key) {
			return filter;
		}
	}

	return false;
}

export function getProjectsToProcess(searchFor, atLeastOne) {
	let projectsToProcess = 0;
	if (SHOW_ALL) {
		for (let i = 0; i < TABS_TO_DISPLAY.length; i++) {
			const tab = TABS_TO_DISPLAY[i];
			projectsToProcess +=
				tab === AGENCY_PROJECT
					? atLeastOne
						? 1
						: 2
					: tab === PROJECT_CAR ||
					  tab === FILIALI_PROJECT ||
					  tab === PROJECT_CSV
					? 1
					: tab === PROJECT_CRI
					? CURRENT_CRI_LIST.length
					: tab === PROJECT_GRA
					? CURRENT_GRA_LIST.length
					: 0;
		}
	} else {
		projectsToProcess =
			searchFor === AGENCY_PROJECT
				? atLeastOne
					? 1
					: 2
				: searchFor === PROJECT_CAR ||
				  searchFor === FILIALI_PROJECT ||
				  searchFor === PROJECT_CSV
				? 1
				: searchFor === PROJECT_CRI
				? CURRENT_CRI_LIST.length
				: searchFor === PROJECT_GRA
				? CURRENT_GRA_LIST.length
				: 0;
	}
	return projectsToProcess;
}

export function isMunicipality(place) {
	if (place) {
		let exit = false;
		let bMunicipality = false;
		let returnValue = null;

		const COUNTRY_TYPE = ['administrative_area_level_3', 'political'];
		const COUNTRY_TYPE_3 = ['locality', 'political'];
		const STREET = ['route', 'street_address', 'street_number'];

		const address_components = place.address_components;

		if (address_components && address_components.length > 0) {
			for (var k = 0; k < address_components.length; k++) {
				const typePlace = address_components[k]['types'];
				let toFound = COUNTRY_TYPE.length;
				let toFound_3 = COUNTRY_TYPE_3.length;

				// cerco se il type corrisponde
				for (var i = 0; i < typePlace.length; i++) {
					var tmp = typePlace[i];

					if (
						tmp === STREET[0] ||
						tmp === STREET[1] ||
						tmp === STREET[2]
					) {
						exit = true;
						bMunicipality = false;
						break;
					} else if (!exit) {
						for (var j = 0; j < COUNTRY_TYPE.length; j++) {
							if (tmp === COUNTRY_TYPE[j]) {
								toFound--;
							}

							if (toFound === 0) {
								bMunicipality = true;
								// isCap = false;
							}
						}

						/** casistica determinate città (ad es. Milano) */
						if (!bMunicipality) {
							for (var h = 0; h < COUNTRY_TYPE_3.length; h++) {
								if (tmp === COUNTRY_TYPE_3[h]) {
									toFound_3--;
								}

								if (toFound_3 === 0) {
									bMunicipality = true;
									// isCap = false;
								}
							}
						}
					}
				}

				// se ho trovato il tipo corretto
				if (bMunicipality) {
					returnValue = address_components[k]['short_name'];
					break;
				}
			}
		}

		return bMunicipality ? returnValue : false;
	} else {
		return false;
	}
}

export function getResultId(obj2beProcess) {
	if (!obj2beProcess) {
		return;
	}
	return (
		obj2beProcess['id'] +
		CHAR_SEPARATOR +
		obj2beProcess['idLayer'] +
		CHAR_SEPARATOR +
		obj2beProcess['idProject']
	);
}

export function getSearchFieldName(project) {
	if (project === AGENCY_PROJECT) return 'Intestatario mandato';
	else if (project === PROJECT_CAR) return 'NomeCarrozzeria';
	else if (project === PROJECT_CSV) return 'STRUTTURA';
	else if (project === PROJECT_CCG) return 'name';
	else if (project === PROJECT_CGL) return 'Nome Centro';
	else if (project === PROJECT_CVC) return 'Nome Centro';
	else if (project === PROJECT_CCC) return 'FILIALE';
	else if (project === PROJECT_CGR) return 'DENOMINAZIONE';
	else if (project === PROJECT_SOS) return 'Anagrafica';
	else if (project === PROJECT_DOG) return 'Ragione Sociale';
	else if (project === PROJECT_NSG) return 'Denominazione'; // TODO: attivare
	else if (project === PROJECT_STS) return 'Denominazione'; // TODO: attivare
}
